const autoNgTemplateLoaderTemplate1 = require('./por-switch.html');

import angular from 'angular';

const porSwitch = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    ngModel: '=',
    id: '@',
    className: '@',
    name: '@',
    disabled: '<',
    onChange: '<',
  },
};

angular.module('portainer.app').component('porSwitch', porSwitch);
